export const HIGHLY_SENSITIVE_MASKED_DISPLAY = '**************';